

import Component from '../inherited/Component'
import axios from 'axios'

export default class MiniCart extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._countries = this._elem.getAttribute('data-minicart-countries');
    this._freeShippingBar = this._elem.querySelector('#MinicartFreeShipping');
    this._cartFreeShipping = this._elem.querySelector('.cart__free-shipping');
    this._endpoint = "https://api.ipstack.com/check?access_key=f5afe73a53b00c85d7a3a4bb003c1cd2"
  }

  async mount () {
    if (this._countries) {
    try {
        let { data } = await axios.get(this._endpoint)
        if (!data.country_code.includes(this._countries)) {
            if(this._freeShippingBar) {
                this._freeShippingBar.classList.add('hide');
            }
            if (this._cartFreeShipping) {
            this._cartFreeShipping.classList.add('hide');
            }
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}